export default "__VITE_ASSET__499a3d4b__"